<form #groupsDiscountForm="ngForm" novalidate>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="group-material-tree">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <li class="mat-tree-node py-1 flex justify-between items-center gap-4">
        <div class="flex items-center">
          <button mat-icon-button disabled></button>
          <div>{{ node.name }}</div>
        </div>

        <div>
          <span class="mat-title" *ngIf="readonly">{{ node.discountPct }}%</span>

          <mat-form-field *ngIf="!readonly" appearance="outline" class="mini-input no-subscript no-label w-24">
            <input
              type="number"
              matInput
              [(ngModel)]="node.discountPct"
              [min]="0"
              [max]="100"
              name="{{ node.id }}"
              ngModel
              (ngModelChange)="discountChange$.next(node)" />
            <span matSuffix>%</span>
          </mat-form-field>
        </div>
      </li>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <li>
        <div class="mat-tree-node py-1 mr-4 flex justify-between items-center gap-4">
          <div class="flex items-center">
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <div>{{ node.name }}</div>
          </div>

          <div>
            <span class="mat-title" *ngIf="readonly">{{ node.discountPct }}%</span>

            <mat-form-field *ngIf="!readonly" appearance="outline" class="mini-input no-subscript no-label w-24">
              <input
                type="number"
                matInput
                [(ngModel)]="node.discountPct"
                [min]="0"
                [max]="100"
                name="{{ node.id }}"
                ngModel
                (ngModelChange)="discountChange$.next(node)" />
              <span matSuffix>%</span>
            </mat-form-field>
          </div>
        </div>
        <ul [class.group-material-tree-invisible]="!treeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>
</form>
